module.exports = {"area_unit":"sqft","phone_number_placeholder":"+1 555 555 5555","Search::number":"MLS ID"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/en-PR.json
// module id = 2288
// module chunks = 244